module.exports = __webpack_public_path__ + "img/Vision.23ea8309.png";